import { useContext } from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { FlexBox } from 'components/Box'
import { Switch } from 'components/Form'
import { SectionHeader } from 'components/Header'
import Paper from 'components/Paper'
import { Alert } from 'features/alerts/types/alert'
import { cypressId } from 'features/inventory/ad-unit/forms/PrebidStackForm/utils'
import { useAbility } from 'providers/casl'
import { AdUnitAlerts } from '../../components/AdUnitAlerts'
import { AddEditAdUnitContext } from '../../contexts/AddEditAdUnitContext'
import { AdUnitAlert } from '../../types/adUnitAlert'
import { Schema } from './schema'
import { BiddersSection } from './sections/BiddersSection'
import { InventoryAmazonUamTamSection } from './sections/InventoryAmazonUamTamSection'

export const Form = (): JSX.Element => {
  const { t } = useTranslation('features/adUnit')
  const { adUnit } = useContext(AddEditAdUnitContext)
  const { control } = useFormContext<Schema>()
  const ability = useAbility()
  const cannotUpdateAdUnit = ability.cannot('update', 'AdUnit')

  if (!adUnit) {
    throw Error('Ad unit should be accessible')
  }
  const { adUnitAmazonEnabled, alerts } = adUnit

  const prebidStackAlerts: Alert<AdUnitAlert>[] = alerts.filter(
    (alert: Alert<AdUnitAlert>): boolean => alert.name.startsWith('prebidStack'),
  )

  return (
    <>
      <Paper data-cy={cypressId('state')}>
        <SectionHeader
          subtitle={t('form.prebidStack.enabled.description')}
          title={t('form.prebidStack.enabled.title')}
          titleEndAdornment={
            <FlexBox axis='x'>
              <Switch
                control={control}
                disabled={cannotUpdateAdUnit}
                name='prebidStackEnabled'
              />

              {prebidStackAlerts.length > 0 && <AdUnitAlerts alerts={prebidStackAlerts} />}
            </FlexBox>
          }
        />
      </Paper>

      <BiddersSection />

      <InventoryAmazonUamTamSection<Schema> amazonState={adUnitAmazonEnabled} />
    </>
  )
}
